export const renderPriorityColor = (priority) => {
    switch (priority) {
        case 'High':
            return 'red';
        case 'Medium':
            return 'purple';
        case 'Low':
            return 'yellow';
        default:
            return 'blue';
    }
}